document.addEventListener('DOMContentLoaded', function() {
  // Query all VIDEO buttons and attach click listeners
  document.querySelectorAll('.button--VIDEO').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      var videoUrl = this.getAttribute('data-video-url');
      if (videoUrl) {
        openVideoModal(videoUrl);
      }
    });
  });

  // Function to open the modal
  function openVideoModal(videoUrl) {
    var modal = document.getElementById('video-modal');
    var iframe = document.getElementById('video-modal-iframe');

    // Build autoplay URL if desired
    var autoplayUrl = videoUrl + (videoUrl.indexOf('?') === -1 ? '?autoplay=1&mute=1' : '&autoplay=1&mute=1');
    iframe.setAttribute('src', autoplayUrl);

    // Show the modal
    modal.classList.add('active');
    modal.style.display = 'block';

    // Add a class to <body> so we can override transforms, etc.
    document.body.classList.add('modal-active');
  }

  // Function to close the modal
  function closeVideoModal() {
    var modal = document.getElementById('video-modal');
    var iframe = document.getElementById('video-modal-iframe');

    modal.classList.remove('active');
    modal.style.display = 'none';
    iframe.setAttribute('src', ''); // stop the video

    // Remove the class from <body>
    document.body.classList.remove('modal-active');
  }

  // Close modal on overlay or close button click
  var modal = document.getElementById('video-modal');
  if (modal) {
    modal.addEventListener('click', function(event) {
      // If the overlay or the close button is clicked, close the modal
      if (
        event.target.classList.contains('video-modal__overlay') ||
        event.target.classList.contains('video-modal__close')
      ) {
        closeVideoModal();
      }
    });
  }
});